/* eslint-disable import/prefer-default-export */
/**
 * Name of the field containing the "master switch" for all email subscription preferences
 */
export const EMAIL_MARKETING_MASTER_SWITCH_FIELD = 'emailSubscribed';
